import {  useEffect } from "react";

import { WL_REASON_ELI_SUICIDE } from "utils/eligibility";
import {
  CLINICAL_PROGRAM,
  CORE_PRODUCT,
  DIABETES_PROGRAM,
  DIABETES_WORKSHOP_PROGRAM,
  GLP1_PROGRAM,
  GLP1_WORKSHOP_PROGRAM,
  PREMIUM_PRODUCT,
} from "utils/resultFunctions/constants";
import { pageView } from "utils/analytics";

import ResultsEliNone from "components/Results/ResultsEliNone";
import ResultsEliSuicide from "components/Results/ResultsEliSuicide";
import { ResultsUni5Default } from "./ResultsUni5Default";
import { ResultsUni5Clinical } from "./ResultsUni5Clinical";
import { loadResultsCookieByBaseUrl } from "components/Results/storeResultsData";
import useUrlSlugContext from "components/UrlSlugContext";
import useAppContext from "components/AppContext";
import { ResultsUni5Cookie } from "types/cookie";

export const ResultsUni5Restored: React.FC = () => {
  const { baseUrl } = useUrlSlugContext();
  const { profile, setProfile, setAnswers } = useAppContext();
  const cookie = loadResultsCookieByBaseUrl(baseUrl) as ResultsUni5Cookie | null;
  const resultsScreen = cookie?.resultsScreen;

  useEffect(() => {
    pageView("result-revisited");
  }, []);

  useEffect(() => {
    if (!cookie?.profile || !setProfile) {
      return;
    }

    setProfile({
      ...profile,
      ...cookie?.profile
    });

    if (!cookie?.answers || !setAnswers) {
      return;
    }

    setAnswers(cookie?.answers);
  }, [setProfile, setAnswers]);

  switch (resultsScreen) {
    case CORE_PRODUCT:
    case PREMIUM_PRODUCT:
    case DIABETES_PROGRAM:
    case DIABETES_WORKSHOP_PROGRAM:
    case GLP1_PROGRAM:
    case GLP1_WORKSHOP_PROGRAM:
      return <ResultsUni5Default resultsScreen={resultsScreen} resultsRestored />;

    case CLINICAL_PROGRAM:
      return <ResultsUni5Clinical resultsRestored />;

    case WL_REASON_ELI_SUICIDE:
      return <ResultsEliSuicide />;

    default:
      return <ResultsEliNone />;
  }
};
